import React, { Component } from 'react'
import View from './View'
import CountryResources from './CountryResources'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faStroopwafel, faAngleRight, faAngleDown, faAngleLeft, faCheckSquare, faSquare, faSearch, faCheck, faEllipsisH, faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons'
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom';

import Stats from '../redux/StatsReducer'

library.add(faStroopwafel, faAngleRight, faAngleDown, faAngleLeft, faCheckSquare, faSquare, faSearch, faCheck, faEllipsisH, faPlusCircle, faMinusCircle)


let store = createStore(Stats, applyMiddleware(thunk));
//console.log(store.getState());

class App extends Component {
  render() {
    return (
      <Provider store={ store }>
        <Router>
          <Switch>
            <Route name="CountryResrouces" path="/countryResources" component={CountryResources} />
            <Route name="View" path="/" component={View} />
          </Switch>
        </Router>
      </Provider>
    );
  }
}

export default App;
{/* <View /> */}



// WEBPACK FOOTER //
// ./src/components/App.js